module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-creative-intro-card1.1.6a5b908b.jpg";